<mat-card class="example-card">
  <h1>Sign up or Registration</h1>
  <button mat-raised-button routerLink="/" routerLinkActive="active">Home</button>
  <button mat-raised-button color="primary" routerLink="/page-auth" routerLinkActive="active">Sign Up</button>
  <button mat-raised-button color="primary" routerLink="/page-reg" routerLinkActive="active">Registration</button>
  <button mat-stroked-button routerLink="/page-target" routerLinkActive="active">Page</button>
  <!-- <button mat-stroked-button (click)="userForm()">Get User</button> -->

</mat-card>

<router-outlet></router-outlet>